export default "__VITE_ASSET__BdXfDFIm__"